import currency from "currency.js";

export const formatCurrency = (value) => {
  const valueFormatted = currency(value, {
    symbol: "R$",
    separator: ".",
    decimal: ",",
    formatWithSymbol: true,
    precision: 2,
  }).format();

  return valueFormatted;
};

// Sem casas decimais — pra valores grandes onde o centavo não importa e só
// atrapalha a leitura (ex.: cards de totalizadores/indicadores do dashboard).
export const formatCurrencyInteiro = (value) => {
  const valueFormatted = currency(value, {
    symbol: "R$",
    separator: ".",
    decimal: ",",
    formatWithSymbol: true,
    precision: 0,
  }).format();

  return valueFormatted;
};
